if ($('.vimeo-player-autoplay-silent')) {
  var vimeo_iframe = $('.vimeo-player-autoplay-silent').each(function (idx, itm) {
    var player = new Vimeo.Player(itm);
    player.ready().then(function () {
      player.setVolume(0);
    });
  });
}